import React, { Component } from 'react';
import { Card, Button, Table, Form, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Loading from '../../Loading';
import { GetListUsers } from '../../../components/Functions/GetUsersInfo';
import './Users.css';

class UsersList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            users: null,
            searchTerm: '',
            sortColumn: null,
            sortDirection: 'asc',
            visibleColumns: {
                Username: true,
                Name: true,
                Surname: true,
                Email: true
            },
        };
    }

    async componentDidMount() {
        const users = await GetListUsers();
        this.setState({ users });
    }

    handleSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value });
    };

    handleSort = (column) => {
        const { sortColumn, sortDirection, users } = this.state;
        let direction = 'asc';

        if (sortColumn === column && sortDirection === 'asc') {
            direction = 'desc';
        }

        const sorted = [...users].sort((a, b) => {
            let aVal = this.getUserAttribute(a, column).toLowerCase();
            let bVal = this.getUserAttribute(b, column).toLowerCase();
            if (aVal < bVal) return direction === 'asc' ? -1 : 1;
            if (aVal > bVal) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        this.setState({
            users: sorted,
            sortColumn: column,
            sortDirection: direction,
        });
    };

    renderSortIcon = (column) => {
        const { sortColumn, sortDirection } = this.state;
        if (sortColumn !== column) return null;
        return sortDirection === 'asc' ? ' ▲' : ' ▼';
    };

    getUserAttribute = (user, key) => {
        switch (key) {
            case 'Username':
                return user.Username || '';
            case 'Name':
                return user.Attributes.find(attr => attr.Name === 'name')?.Value || '';
            case 'Surname':
                return user.Attributes.find(attr => attr.Name === 'family_name')?.Value || '';
            case 'Email':
                return user.Attributes.find(attr => attr.Name === 'email')?.Value || '';
            default:
                return '';
        }
    };

    handleColumnToggle = (column) => {
        this.setState((prevState) => ({
            visibleColumns: {
                ...prevState.visibleColumns,
                [column]: !prevState.visibleColumns[column],
            },
        }));
    };

    render() {
        const { users, searchTerm, visibleColumns } = this.state;
        if (!users) return <Loading />;

        const filteredUsers = users.filter(user =>
            Object.values(visibleColumns).some((visible, index) => {
                if (!visible) return false;
                const key = Object.keys(visibleColumns)[index];
                return this.getUserAttribute(user, key).toLowerCase().includes(searchTerm.toLowerCase());
            })
        );

        const columnLabels = {
            Username: 'Username',
            Name: 'Nome',
            Surname: 'Cognome',
            Email: 'Email',
        };

        return (
            <div>
                <Dropdown className="mb-3">
                    <Dropdown.Toggle variant="secondary" id="dropdown-columns">
                        Mostra / Nascondi Colonne
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ padding: '10px' }}>
                        {Object.entries(visibleColumns).map(([key, visible]) => (
                            <Form.Check
                                key={key}
                                type="checkbox"
                                id={`toggle-${key}`}
                                label={columnLabels[key] || key}
                                checked={visible}
                                onChange={() => this.handleColumnToggle(key)}
                                style={{ marginBottom: '5px' }}
                            />
                        ))}
                    </Dropdown.Menu>
                </Dropdown>

                <Card className="cardModifiche">
                    <Card.Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className="titleCard">Utenti</div>
                        <Link to="/Users/newUser">
                            <Button className="confirmButton">Aggiungi Nuovo Utente</Button>
                        </Link>
                    </Card.Header>
                    <Card.Body>
                        <Form.Control
                            type="text"
                            placeholder="Cerca tra tutti i campi..."
                            value={searchTerm}
                            onChange={this.handleSearchChange}
                            className="mb-3"
                        />
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    {Object.entries(visibleColumns).map(([key, visible]) => (
                                        visible && (
                                            <th key={key} onClick={() => this.handleSort(key)} style={{ cursor: 'pointer' }}>
                                                {columnLabels[key]}{this.renderSortIcon(key)}
                                            </th>
                                        )
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredUsers.map((user, idx) => (
                                    <tr key={idx}>
                                        {Object.entries(visibleColumns).map(([key, visible]) => (
                                            visible && (
                                                <td key={key}>
                                                    {key === 'Username' ? (
                                                        <Link to={`/Users/${user.Username}`}>{this.getUserAttribute(user, key)}</Link>
                                                    ) : (
                                                        this.getUserAttribute(user, key) || '—'
                                                    )}
                                                </td>
                                            )
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default UsersList;
